import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/notification-message-item/notification-message-item.js';
      import {ObcNotificationMessageItemType, ObcNotificationMessageItemSize} from '@oicl/openbridge-webcomponents/dist/components/notification-message-item/notification-message-item.js';

      export interface Props {
     title?: string;
     description?: string;
     time?: string;
     timeSecondary?: string;
     actionLabel?: string;
     type?: ObcNotificationMessageItemType;
     size?: ObcNotificationMessageItemSize;
     showTitle?: boolean;
     showDescription?: boolean;
     showTimestamp?: boolean;
     hasTimestamp2?: boolean;
     hasSecondaryIcon?: boolean;
     large?: boolean;
     empty?: boolean;
     emptyText?: string
   }

      
  
      export type {ObcNotificationMessageItemType, ObcNotificationMessageItemSize} from '@oicl/openbridge-webcomponents/dist/components/notification-message-item/notification-message-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcNotificationMessageItem',
  props: {
    title: {},
    description: {},
    time: {},
    timeSecondary: {},
    actionLabel: {},
    type: {},
    size: {},
    showTitle: { type: Boolean },
    showDescription: { type: Boolean },
    showTimestamp: { type: Boolean },
    hasTimestamp2: { type: Boolean },
    hasSecondaryIcon: { type: Boolean },
    large: { type: Boolean },
    empty: { type: Boolean },
    emptyText: {}
  },
  emits: ["message-click", "action-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onMessageClick: (event: CustomEvent<void>) => emit('message-click', event as CustomEvent<void>),
onActionClick: (event: CustomEvent<void>) => emit('action-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-notification-message-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})